import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

import device from 'config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 30px;

  div {
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  color: var(--greenDark);
  margin: 10px;

  h3 {
    padding: 1px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 0.9rem;
  }

  h3.title {
    justify-content: space-between;
    align-items: center;
    margin: -1%;
    padding-right: 1%;
  }

  p {
    font-size: 1.7rem;

    @media (max-width: 426px) {
      font-size: larger;
    }
  }
`;

export const Tbody = styled.tbody`
  margin: 5px 0;
  width: 100%;

  td.status {
    color: ${props => (props.statusColor ? props.statusColor : '#20303d')};
  }
`;

export const Table = styled.table`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid rgba(207, 207, 207, 0.8);
  padding: 10px 0;
  color: var(--greenDark);
  margin: 20px 40px;
  font-size: 0.8rem;

  @media ${device.mobileMinTabMax} {
    margin: 20px 0;
  }

  #barcodeNumber {
    cursor: pointer;
    color: var(--blueUrl);
    background-color: var(--white);
    border: 0;

    @media (max-width: 426px) {
      font-size: 0.5rem;
      margin-left: 5px;
    }

    &:hover {
      color: ${darken(0.2, '#94d3f3')};
    }
  }

  thead tr {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    color: var(--blueDark);
    font-weight: bold;
    margin-bottom: 1%;
    text-align: center;
    border: 0;

    @media (max-width: 426px) {
      display: flex;
      flex-direction: row;
      font-size: 0.7rem;
      margin: 2px;
    }
  }

  svg {
    color: #f7c325;
    margin-right: 5px;
    cursor: pointer;
  }

  tr {
    display: flex;
    justify-content: space-between;
    text-align: center;

    border-top: 1px solid rgba(207, 207, 207, 0.8);

    @media (max-width: 426px) {
      display: flex;
      flex-direction: row;
      font-size: 0.5rem;
      margin: 2px;
    }
  }

  td {
    margin: 5px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid #767676;
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 0 30px;

    svg {
      cursor: pointer;
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
`;
